// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export function parseSearchParams(url: URL) {
	// read params, `URL.searchParams` is not yet well supported
	const params: {[key: string]: string} = {};
	url.search
			.slice(1)     // slice off the '?'
			.split("&")
			.forEach((kv) => {
				const [k, v] = kv.split("=");
				if (k && v) {
					params[k] = decodeURIComponent(v);
				}
			});
	return params;
}

export function parseHash(url: URL) {
	const params: {[key: string]: string} = {};
	const queryString = window.location.hash.substring(1);
	const regex = /([^&=]+)=([^&]*)/g;
	let match = regex.exec(queryString);
	while (match) {
		params[decodeURIComponent(match[1])] = decodeURIComponent(match[2]);
		match = regex.exec(queryString);
	}
	return params;
}
